import { render, staticRenderFns } from "./TradeCountryDetail.vue?vue&type=template&id=7d854b6c&"
import script from "./TradeCountryDetail.vue?vue&type=script&lang=js&"
export * from "./TradeCountryDetail.vue?vue&type=script&lang=js&"
import style0 from "./TradeCountryDetail.vue?vue&type=style&index=0&id=7d854b6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports